var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgShelter = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.936.293l-3.24 9.559-.04.117L7.36 4.813c-.036-.08-.096-.15-.17-.199-.075-.048-.162-.074-.251-.074s-.176.026-.25.074c-.075.048-.135.119-.17.2l-3.241 7.28-3.24 7.281c-.136.315.11.647.42.647h25.779c.424 0 .537-.32.402-.683l-2.964-5.374-2.964-5.37c-.04-.072-.098-.132-.168-.174-.071-.042-.153-.064-.234-.064-.082 0-.163.023-.234.064-.07.042-.13.102-.169.173l-2.033 3.681-.82-2.423L13.81.292c-.141-.365-.724-.413-.871 0h-.003z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShelter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shelter.d2c3b130.svg";
export { ForwardRef as ReactComponent };